import { CookieConsentDialog } from "@/components/CookieConsent/CookieConsentDialog";
import { useGetUserConsentStatusV1Query } from "@/store/clientApi";
import { ReactElement } from "react";

export const CookieGuard = ({ children }: { children: ReactElement }) => {
  const { data: userConsentStatuses } = useGetUserConsentStatusV1Query();

  const allConsentsAccepted = userConsentStatuses?.every((s) => !s.document.required_for_access || s.status === "accepted") ?? false;

  return (
    <>
      {allConsentsAccepted && <CookieConsentDialog />}
      {children}
    </>
  );
};
